module.exports = __webpack_public_path__ + "static/media/OpenDyslexic-Regular.57618c91.otf";